import { combineReducers } from 'redux';
import config from './config';

import { reducer as dataCutFacetSearch } from './modules/dataCuts/dataCutFacetSearch';
import { reducer as jobFacetSearch } from './modules/jobs/jobFacetSearch/jobFacetSearch';
import { reducer as marketPaySurveyLibrarySearch } from '../components/SurveyLibraryUpdate/MarketPaySurveyLibrary/facet/MarketPaySurveyLibraryFacet';
import { reducer as surveyFacetSearch } from './modules/surveys/surveyFacetSearch/surveyFacetSearch';
import addJob from 'ps-components/Modules/AddJob/reducers/addJob';
import addJobStructureList from 'ps-components/Modules/AddJob/reducers/addJobStructureList';
import addJobUpdatedDetails from 'ps-components/Modules/AddJob/reducers/addJobUpdatedDetails';
import aging from './modules/aging/aging';
import careerLevels from 'ps-components/Modules/AddJob/reducers/careerLevels';
import compensationSummary from '../components/CompensationSummary/CompensationSummaryReducer';
import competitiveSets from 'ps-components/Modules/CompetitiveSets/reducers/competitiveSets';
import currency from './modules/currency/currency';
import dataCutMigration from '../components/DataCutMigration/reducers/DataCutMigrationReducer';
import dataCuts from '../components/Rules/DataCutsReducer';
import employees from './modules/employees/employees';
import features from 'ps-components/FeatureFlags/FeatureFlagReducer';
import geoDifferential from 'ps-components/Modules/PayScalePulse/GeoDifferential/GeoDifferentialReducer';
import group from './modules/group/group';
import groups from './groups';
import jobCertifications from 'ps-components/Modules/AddJob/reducers/jobCertifications';
import jobDetails from 'ps-components/Modules/AddJob/reducers/jobDetails';
import jobDetailsData from '../components/MarketPricing/JobDetails/JobDetailsReducer';
import jobEmployees from '../components/MarketPricing/JobEmployees/JobEmployeesReducer';
import jobFamilies from 'ps-components/Modules/AddJob/reducers/jobFamilies';
import jobMatching from './modules/jobs/jobMatching/jobMatching';
import jobPricingStatus from './modules/jobs/jobPricingStatus/jobPricingStatus';
import jobRanges from 'ps-components/Modules/JobRanges/reducers/jobRanges/index';
import jobSurveyList from 'ps-components/Modules/AddJob/reducers/jobSurveyList';
import landingDashboard from '../components/LandingDashboardPage/LandingDashboardReducer';
import landingPage from '../components/MarketPricing/LandingPage/LandingPageReducer';
import marketIndex from './modules/organization/marketIndex/marketIndex';
import marketPricing from '../components/MarketPricing/MarketPricingReducer';
import marketRateChart from 'ps-components/Modules/AddJob/reducers/marketRateChart';
import modal from './modal';
import organizations from './organizations';
import organizationStatistics from './modules/organization/organizationStatistics/organizationStatistics';
import orgJobs from '../components/JobMatching/OrgJobsReducer';
import participationCenter from 'ps-components/Modules/ParticipationCenter/reducers/ParticipationCenterReducer';
import preferences from './modules/preferences/preferences';
import pricingTrends from './modules/organization/pricingTrends/pricingTrends';
import recentReports from './modules/recentReports/recentReports';
import reports from 'ps-components/Modules/ReportLibrary/ReportReducer';
import reviewGeoDifferential from 'ps-components/Modules/PayScalePulse/GeoDifferential/ReviewImpact/ReviewImpactReducer';
import rules from '../components/Rules/RulesReducer';
import salaryRangeSlideout from '../components/SalaryRangeSlideout/SalaryRangeReducer';
import saveJobPricing from '../components/MarketPricing/Save/SaveJobPricingReducer';
import session from './session';
import skillGeoDifferential from '../components/SkillGeoDifferential/SkillGeoDifferentialReducer';
import skillsByJobList from 'ps-components/Modules/AddJob/reducers/skillsByJobList';
import slideout from 'ps-components/Slideout/SlideoutReducer';
import slottedSearch from '../components/MarketPricing/SlottedJobSearch/SlottedSearchReducer';
import structureModeling from '../components/StructureModeling/StructureModelingReducer';
import suggestCareer from 'ps-components/Modules/AddJob/reducers/suggestCareer';
import suggestFamily from 'ps-components/Modules/AddJob/reducers/suggestFamily';
import support from 'ps-components/Modules/Support/reducers/index';
import surveyActivity from './modules/surveys/surveyActivity/surveyActivity';
import surveyJobDataCuts from '../components/MarketPricing/SurveyJobDataCuts/SurveyJobDataCutsReducer';
import surveyJobs from '../components/JobMatching/SurveyJobsReducer';
import surveyLibraryChange from '../components/SurveyLibraryUpdate/SurveyLibraryChangeReducer';
import surveyLibraryUpdateAgreement from '../components/SurveyLibraryUpdate/Agreement/SLUAgreementReducer';
import surveyMigration from '../components/SurveyMigration/reducers/SurveyMigrationReducer';
import surveys from './modules/surveys/surveys';
import video from './video';
import yearOverYear from '../components/YearOverYear/YearOverYearReducer';

const rootReducer = combineReducers({
  addJob,
  addJobStructureList,
  addJobUpdatedDetails,
  aging,
  careerLevels,
  compensationSummary,
  competitiveSets,
  config,
  currency,
  dataCutFacetSearch,
  dataCutMigration,
  dataCuts,
  employees,
  features,
  geoDifferential,
  group,
  groups,
  jobCertifications,
  jobDetails,
  jobDetailsData,
  jobEmployees,
  jobFacetSearch,
  jobFamilies,
  jobMatching,
  jobPricingStatus,
  jobRanges,
  jobSurveyList,
  landingDashboard,
  landingPage,
  marketIndex,
  marketPaySurveyLibrarySearch,
  marketPricing,
  marketRateChart,
  modal,
  organizations,
  organizationStatistics,
  orgJobs,
  participationCenter,
  preferences,
  pricingTrends,
  recentReports,
  reports,
  reviewGeoDifferential,
  rules,
  salaryRangeSlideout,
  saveJobPricing,
  session,
  skillGeoDifferential,
  skillsByJobList,
  slideout,
  slottedSearch,
  structureModeling,
  suggestCareer,
  suggestFamily,
  support,
  surveyActivity,
  surveyFacetSearch,
  surveyJobDataCuts,
  surveyJobs,
  surveyLibraryChange,
  surveyLibraryUpdateAgreement,
  surveyMigration,
  surveys,
  video,
  yearOverYear
});

export default rootReducer;
